import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reportsACLFilter'
})

export class ReportsACLFilterPipe implements PipeTransform {

  transform(value: any, input: string, trigger: any) {
    if (input) {

      input = input.toLowerCase();

      return value.filter(function (obj: any) {
        if ((obj.reportName.toLowerCase().indexOf(input) > -1) || (obj.reportDescription.toLowerCase().indexOf(input) > -1) || (obj.reportGroup.toString().toLowerCase().indexOf(input) >-1 )) {
          return obj
        }
      })
    }
    return value;
  }

  //transform(value: any[], input: string):any[] {
  //  if (!value || !input) {
  //    return value
  //  }
  //  return value.filter(report)
  //}




}
